import React, { Component } from 'react'

import TableInformation from '../texts/TableInformation'
import TextWithFieldname from '../texts/TextWithFieldname';
import ContMessageI18N from '../../containers/ContMessageI18N';
import IconRender from '../std/IconRender';


class TestParameters extends Component {

	handleDelete(code) {
		this.props.onChangeParameters(null);
	}
	getLabel(fieldname, objectname) {
		const objectnamePart = objectname ? `.${objectname}` : '';
		return this.props.settings.isDevelopperView ? fieldname	
				: this.getMessage(`parameters${objectnamePart}.${fieldname}`);
	}
	getItemLabel(value, fieldname, objectname) {
		const objectnamePart = objectname ? `.${objectname}` : '';
		const textPart = this.getMessage(`parameters${objectnamePart}.${fieldname}.${value}`);
		return `${value} - ${textPart}`;
	}
	getMessage(i18nKey) {
		return <ContMessageI18N i18n={i18nKey} />
	}

	render() {
		var paramValues = { ...this.props.parameters };
		delete paramValues['services'];
		return (
			<div className="row">
				<div className="col-auto">
					<button className="btn btn-light" onClick={() => this.handleDelete()} >
						<IconRender name="trash" />
					</button>
				</div>
				<div className="row">
					<TableInformation
						developperView={this.props.settings.isDevelopperView}
						values={paramValues}
						i18nPrefix='parameters'
						fieldname='parameters'
					/>
					<TextWithFieldname fieldname='parameters.services' developperView={this.props.settings.isDevelopperView} complexChild={true}>
						{!this.props.settings.isDevelopperView && <h6>{this.getMessage('parameters.services')}</h6>}
						<table className="table table-light table-striped">
							<thead>
								<tr className='table-primary'>
									<th>{this.getLabel('included', 'services')}</th>
									<th>{this.getLabel('serviceCode', 'services')}</th>
									<th>{this.getLabel('packageCode', 'services')}</th>
									<th>{this.getLabel('duration', 'services')}</th>
									<th>{this.getLabel('globalMileage', 'services')}</th>
								</tr>
							</thead>
							<tbody>
								{this.props.parameters.services && this.props.parameters.services.map((occurence, index) => (
									<tr key={index}>
										<td ><input className="form-check-input" type="checkbox" checked={occurence.included} readOnly={true} /></td>
										<td >{occurence.serviceCode}</td>
										<td >{occurence.packageCode}</td>
										<td >{occurence.duration}</td>
										<td >{occurence.globalMileage}</td>
									</tr>
								))}
							</tbody>
						</table>
					</TextWithFieldname>
				</div>
			</div>
		)
	}
}

export default (TestParameters)
